import i18n from "@/i18n";

/** Translate analytics namespace keys outside React components. */
export function at(
  key: string,
  defaultValue?: string,
  options?: Record<string, unknown>,
): string {
  return i18n.t(`analytics.${key}`, {
    defaultValue: defaultValue ?? key,
    ...options,
  });
}
